import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { ToastContainer, Slide } from 'react-toastify';
import { asyncPreloadProcess } from './states/isPreload/action';
import ThreadsPage from './pages/ThreadsPage';
import MyThreadsPage from './pages/MyThreadsPage';
import DetailPage from './pages/DetailPage';
import LeaderboardPage from './pages/LeaderboardPage';
import MyProfilePage from './pages/MyProfilePage';
import AddNewThreadPage from './pages/AddNewThreadPage';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import NotFoundPage from './pages/NotFoundPage';
import Header from './components/Header';
import Loading from './components/utilities/Loading';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const { authUser = {}, isPreload = false } = useSelector((state) => state);
  const dispatch = useDispatch();

  const { theme } = localStorage;

  useEffect(() => {
    dispatch(asyncPreloadProcess());
  }, [dispatch]);

  if (isPreload) return null;

  return (
    <div className="font-sans text-zinc-700 dark:text-zinc-300 bg-white dark:bg-zinc-800">
      <Loading />
      <div className="min-h-screen max-w-screen-xl mx-auto relative">
        <ToastContainer theme={theme} transition={Slide} />
        <Header />
        <main className="mx-4 sm:mx-20 pb-40 md:pb-20 pt-[75px] md:pt-[100px]">
          <Routes>
            <Route path="/" element={<ThreadsPage />} />
            <Route path="/detail/:id" element={<DetailPage />} />
            {authUser ? (
              <>
                <Route path="/my-threads" element={<MyThreadsPage />} />
                <Route path="/leaderboard" element={<LeaderboardPage />} />
                <Route path="/my-profile" element={<MyProfilePage />} />
                <Route path="/add-new-thread" element={<AddNewThreadPage />} />
                <Route path="/register" element={<Navigate to="/" replace />} />
                <Route path="/login" element={<Navigate to="/" replace />} />
                <Route path="*" element={<NotFoundPage />} />
              </>
            ) : (
              <>
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </>
            )}
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default App;
